export default {
  namespaced: true,
  state() {
    return {
      flow: undefined,
      context: undefined,
      createdAt: undefined,
    }
  },
  mutations: {
    SET_REDIRECT(state, payload) {
      state.flow = payload?.flow
      state.context = payload?.context
      state.createdAt = payload?.createdAt
    },
    CLEAR_REDIRECT(state) {
      state.flow = undefined
      state.context = undefined
      state.createdAt = undefined
    },
  },
  actions: {
    setRedirect({ commit }, { flow, context }) {
      commit('SET_REDIRECT', {
        flow,
        context,
        createdAt: Date.now(),
      })
    },
    consumeRedirect({ state, commit }) {
      const ttlMs = 10 * 60 * 1000
      const createdAt = Number(state.createdAt || 0)
      const isExpired = !createdAt || Date.now() - createdAt > ttlMs
      if (isExpired || !state.flow) {
        commit('CLEAR_REDIRECT')
        return null
      }
      const payload = { flow: state.flow, context: state.context }
      commit('CLEAR_REDIRECT')
      return payload
    },
  },
  getters: {
    flow: state => state.flow,
    context: state => state.context,
    createdAt: state => state.createdAt,
  },
}
